import { AnimatedSection } from "./AnimatedSection";
import { TrendingUp, Globe2, ShieldCheck, Zap } from "lucide-react";

const FORCES = [
  {
    icon: Globe2,
    stat: "$8T+",
    label: "Annual global food trade",
    desc: "Still routed through fragmented brokers, paper LCs, and fax-era documentation.",
  },
  {
    icon: TrendingUp,
    stat: "60–90 days",
    label: "Working capital lock-up",
    desc: "Exporters wait months for payment while importers carry forward exposure on every shipment.",
  },
  {
    icon: ShieldCheck,
    stat: "1 in 4",
    label: "Trades face dispute or delay",
    desc: "Quality, paperwork, and counterparty risk go unverified until cargo is already in motion.",
  },
  {
    icon: Zap,
    stat: "<5%",
    label: "Of food trade is digitized",
    desc: "The infrastructure layer that won fintech and logistics has not yet reached cross-border food.",
  },
];

export function InvestorTrigger() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden" data-testid="investor-trigger-section">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
        <AnimatedSection>
          <p className="text-[#22C55E] text-sm font-medium tracking-widest uppercase mb-4">
            Why This Matters
          </p>
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            Why this is inevitable
          </h2>
          <div className="mt-8 space-y-6">
            <p className="text-[#A1B2A8] text-base lg:text-lg leading-relaxed">
              The world&apos;s food supply moves on a financial and operational stack that has not been rebuilt in 50 years — fragmented brokers, manual paperwork, opaque counterparties, and capital that arrives weeks after cargo.
            </p>
            <p className="text-[#A1B2A8] text-base lg:text-lg leading-relaxed">
              Every other multi-trillion dollar flow — payments, equities, logistics — has been re-platformed onto structured digital infrastructure. Cross-border food trade is the largest category that has not.
            </p>
            <p className="text-white text-base lg:text-lg leading-relaxed font-medium">
              Delta GreenX is the structured execution layer for global food trade — verified counterparties, AI-screened deals, and capital that moves with the cargo.
            </p>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.2}>
          <div className="relative grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="why-inevitable-stats">
            {FORCES.map((f, i) => (
              <div
                key={i}
                className="border border-[#1A2E22] bg-[#09120D]/80 p-5 hover:border-[#22C55E]/40 transition-colors"
                data-testid={`force-stat-${i}`}
              >
                <f.icon className="w-5 h-5 text-[#22C55E] mb-3" />
                <p className="font-['Outfit'] text-2xl sm:text-3xl font-bold text-white tracking-tight">
                  {f.stat}
                </p>
                <p className="text-[#22C55E] text-[10px] uppercase tracking-[0.18em] font-semibold mt-1 mb-2">
                  {f.label}
                </p>
                <p className="text-[#A1B2A8] text-xs leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
